var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('hero',{attrs:{"title":"who I am & what I do"}}),_c('bodyContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }